import { Button, Classes, Dialog, Intent, Tabs, Tab, TabId } from '@blueprintjs/core'
import { BotDetails } from 'enablex/sdk'
import { lang, toast } from 'enablex/shared'
import React, { FC, useState } from 'react'
import CodeSnippetIcon from '~/icons/CodeSnippetIcon'
import WebTab from './WebTab'
import WhatsAppTab from './WhatsAppTab'
import RcsTab from './RcsTab'
import htmlToCanvas from './htmlToCanvas'
import { saveAsJPEG } from './canvasToImage'
import VoiceBotTab from './VoiceBotTab'
interface Props {
  botId: string | null
  whiteListedDomains: string[]
  details: BotDetails
  name: string
  isOpen: boolean
  toggle: () => void
}

const DeployModal: FC<Props> = props => {

  const [navbarTabId, setNavbarTabId] = useState('web' as any)

  const submit = async () => {
    closeModal()
  }

  const copyToClipboard = async () => {
    const preElement = document.querySelector('pre#copy-deploy-code')
    const codeText = preElement?.textContent
    if(codeText) {
      navigator.clipboard.writeText(codeText)
      .then(() => {
        console.log('Text copied to clipboard')
        toast.info('Copied to clipboard')
      })
      .catch((error) => {
        console.error('Failed to copy text to clipboard:', error)
      })
    }
  }

  const downloadQR = () => {
    const qrContainer = `#download-${navbarTabId}-QR`
    htmlToCanvas(document.querySelector(qrContainer), {
      height: document.querySelector(qrContainer)?.getClientRects()[0].height,
      imageTimeout: 5000,

      onclone: (clonedDoc) => {
        clonedDoc.querySelector(qrContainer).style.padding = '20px'
        clonedDoc.querySelector(qrContainer).style.backgroundColor = '#eef0f8'
        const text = `${qrContainer} g text`
        clonedDoc.querySelectorAll(text).forEach((item) => {
          item.style.zIndex = '100000'
        })
      }
    }).then(canvas => {
      let bodyHeight = document.querySelector(qrContainer)?.getClientRects()[0].height
      let bodyWidth = document.querySelector(qrContainer)?.getClientRects()[0].width

      saveAsJPEG(canvas, bodyWidth, bodyHeight, `${props.name}_${props.botId}`)
    }).catch(error => {
      console.log('Screenshot error ', error)
      toast.failure('Failed to import image , try in another browser.')
    })
  }

  const closeModal = () => {
    props.toggle()
  }

  const handleNavbarTabChange = (selNavbarTabId: TabId) => {
    setNavbarTabId(selNavbarTabId)
  }

  return (
    <Dialog
      isOpen={props.isOpen}
      icon={<CodeSnippetIcon />}
      onClose={closeModal}
      transitionDuration={0}
      title={lang.tr('admin.workspace.bots.deploy_header', { bot: props.botId })}
    >
      <div className={Classes.DIALOG_BODY}>
        {
          (props.details?.isWhatsappEnabled && props.details?.selectedProject?.wa_phone_number) || (props.details?.isVoiceBotEnabled && props.details?.selectedProject?.voice_phone_number) ?
            <Tabs
              id={'div-deploy-tabs'}
              key={'horizontal'}
              onChange={handleNavbarTabChange}
              large={true}
              vertical={false}
              animate={true}
              selectedTabId={navbarTabId}
            >
              <Tab
                id={'web'}
                title={'Web - Code Snippet'}
                panel={
                  <WebTab modalProps={props} />
                }
              />
              {
                props.details?.isWhatsappEnabled && props.details?.selectedProject?.wa_phone_number ?
                <Tab
                  id={'whatsapp'}
                  title={'WhatsApp'}
                  panel={
                    <WhatsAppTab modalProps={props} />
                  }
                /> : <></>
              }
              {
                props.details?.isRcsEnabled && props.details?.selectedProject?.rcs_phone_number ?
                <Tab
                  id={'rcs'}
                  title={'RCS'}
                  panel={
                    <RcsTab modalProps={props} />
                  }
                /> : <></>
              }
              {
                props.details?.isVoiceBotEnabled && props.details?.selectedProject?.voice_phone_number ?
                <Tab
                  id={'voiceBot'}
                  title={'Voice Bot'}
                  panel={
                    <VoiceBotTab modalProps={props} />
                  }
                /> : <></>
              }
              <Tabs.Expander />
            </Tabs> :
            <>
              <p style={{fontFamily: 'Barlow SemiBold', marginBottom: '20px'}}>Web - Code Snippet</p>
              <WebTab modalProps={props} />
            </>
        }
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            id="btn-submit-rollback"
            text={lang.tr('Close')}
            tabIndex={3}
            onClick={submit}
            intent={Intent.PRIMARY}
          />
          {
            (props.details?.isWhatsappEnabled && navbarTabId === 'whatsapp') || (props.details?.isRcsEnabled && navbarTabId === 'rcs') || (props.details?.isVoiceBotEnabled && navbarTabId === 'voiceBot') ?
            <Button
              text={lang.tr('Download QR')}
              onClick={downloadQR}
              intent={Intent.PRIMARY}
            /> :
            <Button
              id="btn-submit-rollback"
              text={lang.tr('Copy to Clipboard')}
              tabIndex={3}
              onClick={copyToClipboard}
              intent={Intent.PRIMARY}
            />
          }
        </div>
      </div>
    </Dialog>
  )
}

export default DeployModal
